export const useContentfulInspectorMode = () => {
    return (_props: any) => { return {} };
}
export const useContentfulLiveUpdates = <T>(props: T): T => props;